import { render, staticRenderFns } from "./CategoriesQuickSearch.vue?vue&type=template&id=56bc48e7&scoped=true"
import script from "./CategoriesQuickSearch.vue?vue&type=script&lang=js"
export * from "./CategoriesQuickSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56bc48e7",
  null
  
)

export default component.exports